import * as form from '../form';

export const substanceAlcoholVoluntary = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        CounselingDates: form.daterange(xitem.CounselingDates),
        TreatmentProviderName: form.text(xitem.TreatmentProviderName),
        TreatmentProviderAddress: form.location(xitem.TreatmentProviderAddress),
        TreatmentProviderTelephone: form.telephone(xitem.TreatmentProviderTelephone),
        CompletedTreatment: form.branch(xitem.CompletedTreatment),
        NoCompletedTreatmentExplanation: form.textarea(xitem.NoCompletedTreatmentExplanation),
        Comments: form.textarea(xitem.Comments),
        CompletedTreatmentComments: form.textarea(xitem.CompletedTreatmentComments),
        TreatmentProviderNameNotApplicable: form.notapplicable(xitem.TreatmentProviderNameNotApplicable), // PVQ Only
        TreatmentProviderPersonName: form.name(xitem.TreatmentProviderPersonName), // PVQ Only
        TreatmentProviderAddressNotApplicable: form.notapplicable(xitem.TreatmentProviderAddressNotApplicable), // PVQ Only
        TreatmentProviderPhones: form.collection(form.telephoneCollection(xitem.TreatmentProviderPhones)), // PVQ Only
        TreatmentProviderEmails: form.collection(form.emailCollection(xitem.TreatmentProviderEmails)), // PVQ Only
        ProviderStillPractices: form.branch(xitem.ProviderStillPractices), // PVQ Only
        RecommendedBy: form.checkboxgroup(xitem.RecommendedBy), // PVQ Only
        RecommendedByExplanation: form.textarea(xitem.RecommendedByExplanation), // PVQ Only
        PracticeName: form.text(xitem.PracticeName), // PVQ Only
        PracticeNameNotApplicable: form.notapplicable(xitem.PracticeNameNotApplicable), // PVQ Only
      },
    };
  });
  return {
    SoughtTreatment: form.branch(data.SoughtTreatment),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
